import ProHorizontalLayout from './ProHorizontalLayout.js';
import HorizontalLayoutPack from '../../Scheduler/eventlayout/HorizontalLayoutPack.js';

/**
 * @module SchedulerPro/eventlayout/ProHorizontalLayoutPack
 */

/**
 * Handles layout of events within a row (resource) in horizontal mode. Packs events (adjusts their height) to fit
 * available row height.
 *
 * This layout supports grouping events inside the resource row. See
 * {@link SchedulerPro.eventlayout.ProHorizontalLayout} for more info.
 *
 * @mixes SchedulerPro/eventlayout/ProHorizontalLayout
 */
export default class ProHorizontalLayoutPack extends HorizontalLayoutPack.mixin(ProHorizontalLayout) {
    static $name = 'ProHorizontalLayoutPack';

    /**
     * @hideconfigs type, weights, groupBy, layoutFn
     */

    layoutEventsInBands(events) {
        const
            me = this,
            groups = me.getEventGroups(events),
            // If we don't have any groups, treat it like we have a single group including all events
            groupCount = groups.length || 1;

        let minSlotSize = 1,
            scale = 1;

        const result = me.packEventsInBands(events, (event, j, slot, slotSize) => {
            const
                size              = slotSize / groupCount,
                groupIndex        = groupCount === 1 ? 0 : groups.indexOf(event.group),
                adjustedSlotStart = groupIndex / groupCount;

            // This height and top are used to position event in the grouped row
            event.height = size;
            event.top    = adjustedSlotStart + slot.start / groupCount + j * size;

            // This height and top are used to layout events in the same band. They emulate a single row which is what
            // pack logic expects
            event.inBandHeight = slotSize;
            event.inBandTop = slot.start + j * slotSize;

            if (slotSize < minSlotSize) {
                minSlotSize = slotSize;
            }
        });

        if (events.length) {
            const {
                contentHeight,
                minPackSize
            } = me.scheduler.getResourceLayoutSettings(events[0].resourceRecord);

            // If we have a minPackSize, and the smallest event slot is too small to reach it, scale them all up and
            // grow the row height to fit
            if (minPackSize > 0 && minSlotSize * contentHeight < minPackSize) {
                scale = minPackSize / (minSlotSize * contentHeight);
            }

            events.forEach(event => {
                Object.assign(
                    event,
                    me.bandIndexToPxConvertFn.call(
                        me.bandIndexToPxConvertThisObj || me,
                        event.top,
                        event.height,
                        event.eventRecord,
                        event.resourceRecord,
                        scale
                    )
                );
            });
        }

        return result * scale;
    }
}
